const PLACEHOLDER = '—'

export const formatSeconds = (ms: number | null): string => {
  if (ms === null) return PLACEHOLDER
  const seconds = ms / 1000
  return `${seconds.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 })} s`
}

export const formatMilliseconds = (ms: number | null): string =>
  ms === null ? PLACEHOLDER : `${Math.round(ms).toLocaleString()} ms`

export const formatTokenCount = (tokens: number | null): string =>
  tokens === null ? PLACEHOLDER : tokens.toLocaleString()

const fractionDigitsFor = (amount: number): number => (Math.abs(amount) < 1 ? 4 : 2)

export const formatCost = (amount: number | null, currency: string | null): string => {
  if (amount === null) return PLACEHOLDER
  const maximumFractionDigits = fractionDigitsFor(amount)
  if (currency) {
    try {
      return amount.toLocaleString(undefined, { style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits })
    } catch {
      return `${currency} ${amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits })}`
    }
  }
  return amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits })
}

export const formatEstimatedCost = (amount: number | null, currency: string, isEstimate: boolean): string => {
  const formatted = formatCost(amount, currency)
  return amount !== null && isEstimate ? `≈ ${formatted}` : formatted
}

export const formatPersonName = (firstName: string | null, lastName: string | null): string => {
  const fullName = [firstName, lastName].filter((part) => part && part.trim()).join(' ')
  return fullName || 'Unknown user'
}

export const formatEmail = (email: string | null): string => email || PLACEHOLDER
